// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"h5-z"};